module.exports = "/assets/1c097367f64aafde471b38bb39f5a6bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/G9.png
// module id = 2522
// module chunks = 0